'use client';
import React from 'react';
import ProductDetailWaysToWear from '../../../../../../components/customercenter-ui/components/product/details/components/pdpWaystoWear';

const PdpWaysToWearTastic = (data: any) => {
  return <ProductDetailWaysToWear data={data?.data} />;
};

export default PdpWaysToWearTastic;
